import React from "react";
import { Button, Notification } from "@flixbus/honeycomb-react";
import styles from "./OperationalDataStates.module.scss";

export const OperationalDataError: React.FC<{ onRetry: () => void }> = ({
  onRetry,
}) => (
  <Notification appearance="danger" extraClasses={styles.banner}>
    {"Couldn't load operational data."}{" "}
    <Button appearance="primary" onClick={onRetry}>
      Retry
    </Button>
  </Notification>
);

export const OperationalDataEmpty: React.FC<{ line: string; year: number }> = ({
  line,
  year,
}) => (
  <p className={styles.state}>
    {`No operational data for ${line} / ${year} yet.`}
  </p>
);

export const OperationalDataNoYears: React.FC<{ line: string }> = ({
  line,
}) => <p className={styles.state}>{`No operational data for ${line} yet.`}</p>;

export const OperationalDataPrompt: React.FC = () => (
  <p className={styles.state}>
    {"Select a line to view its operational data."}
  </p>
);
